import { Product } from "../../api/entities/Product";
import {
  EuiFieldText,
  EuiFormRow,
  EuiFieldNumber,
  EuiTextArea,
  EuiPanel,
  EuiFlexGroup,
  EuiFlexItem,
  EuiButton,
  EuiText,
  EuiButtonEmpty,
  EuiCheckbox,
} from "@elastic/eui";
import { FieldPercentage } from "../../components/fields/FieldPercentage";
import { useEffect, useState } from "react";

export interface IProductEditor {
  product: Product;
  onUpdateProduct: (product: Product) => void;
  onSaveClick: () => void;
  isLoading?: boolean;
  isDisabled?: boolean;
}

export const ProductEditor: React.FC<IProductEditor> = (props) => {
  const [productPriceChecked, setProductPriceChecked] = useState(
    props.product.pricePerMonth !== undefined &&
      props.product.pricePerMonth !== null,
  );
  const [netCommissionableRevenueChecked, setnetCommissionableRevenueChecked] =
    useState(
      props.product.netCommissionableRevenue !== undefined &&
        props.product.netCommissionableRevenue !== null,
    );
  const [setupFeeChecked, setSetupFeeChecked] = useState(
    props.product.setupFee !== undefined && props.product.setupFee !== null,
  );

  useEffect(() => {
    setProductPriceChecked(
      props.product.pricePerMonth !== undefined &&
        props.product.pricePerMonth !== null,
    );
    setnetCommissionableRevenueChecked(
      props.product.netCommissionableRevenue !== undefined &&
        props.product.netCommissionableRevenue !== null,
    );
    setSetupFeeChecked(
      props.product.setupFee !== undefined && props.product.setupFee !== null,
    );
  }, [props.product.id]);

  const onSaveClick = () => {
    props.onSaveClick();
  };

  const onOverrideProductPriceChecked = () => {
    setProductPriceChecked((val) => {
      const newValue = !val;

      props.onUpdateProduct({
        ...props.product,
        pricePerMonth: newValue
          ? (props.product.pricePerMonth ?? 0)
          : undefined,
      });

      return newValue;
    });
  };

  const onOverridenetCommissionableRevenueChecked = () => {
    setnetCommissionableRevenueChecked((val) => {
      const newValue = !val;

      props.onUpdateProduct({
        ...props.product,
        netCommissionableRevenue: newValue
          ? (props.product.netCommissionableRevenue ?? 0)
          : undefined,
      });

      return newValue;
    });
  };

  const onOverrideSetupFeeChecked = () => {
    setSetupFeeChecked((val) => {
      const newValue = !val;

      props.onUpdateProduct({
        ...props.product,
        setupFee: newValue ? (props.product.setupFee ?? 0) : undefined,
      });

      return newValue;
    });
  };

  return (
    <EuiPanel hasBorder={true} hasShadow={false}>
      <EuiFormRow label={"Product Name"}>
        <EuiFieldText
          value={props.product.name}
          onChange={(e) =>
            props.onUpdateProduct({ ...props.product, name: e.target.value })
          }
        />
      </EuiFormRow>
      <EuiFormRow label={"Product Description"}>
        <EuiTextArea
          value={props.product.description}
          onChange={(e) =>
            props.onUpdateProduct({
              ...props.product,
              description: e.target.value,
            })
          }
        />
      </EuiFormRow>
      <EuiFormRow label={"Duration"}>
        <EuiText>
          <p>{props.product.contractLengthMonths} months</p>
        </EuiText>
      </EuiFormRow>
      <EuiFormRow label={"Maximum Discount"}>
        <FieldPercentage
          value={props.product.maxDiscount}
          onChange={(val) =>
            props.onUpdateProduct({ ...props.product, maxDiscount: val })
          }
        />
      </EuiFormRow>
      <EuiFormRow>
        <EuiCheckbox
          id="overrideProductPrice"
          onChange={onOverrideProductPriceChecked}
          checked={productPriceChecked}
          label="Override Product Price"
        />
      </EuiFormRow>
      {productPriceChecked && (
        <EuiFormRow label={"Product Price"}>
          <EuiFieldNumber
            prepend={"$"}
            append={"/ month"}
            value={props.product.pricePerMonth}
            onChange={(e) =>
              props.onUpdateProduct({
                ...props.product,
                pricePerMonth: parseFloat(e.target.value),
              })
            }
          />
        </EuiFormRow>
      )}
      <EuiFormRow>
        <EuiCheckbox
          id="overridenetCommissionableRevenue"
          onChange={onOverridenetCommissionableRevenueChecked}
          checked={netCommissionableRevenueChecked}
          label="Override Net Commissionable Revenue"
        />
      </EuiFormRow>
      {netCommissionableRevenueChecked && (
        <EuiFormRow label={"Net Commissionable Revenue"}>
          <EuiFieldNumber
            prepend={"$"}
            value={props.product.netCommissionableRevenue}
            onChange={(e) =>
              props.onUpdateProduct({
                ...props.product,
                netCommissionableRevenue: parseFloat(e.target.value),
              })
            }
          />
        </EuiFormRow>
      )}
      <EuiFormRow>
        <EuiCheckbox
          id="overrideSetupFee"
          onChange={onOverrideSetupFeeChecked}
          checked={setupFeeChecked}
          label="Override Setup Fee"
        />
      </EuiFormRow>
      {setupFeeChecked && (
        <EuiFormRow label={"Setup Fee"}>
          <EuiFieldNumber
            prepend={"$"}
            value={props.product.setupFee}
            onChange={(e) =>
              props.onUpdateProduct({
                ...props.product,
                setupFee: parseFloat(e.target.value),
              })
            }
          />
        </EuiFormRow>
      )}
      <EuiFormRow>
        <EuiFlexGroup>
          <EuiFlexItem grow={false}>
            <EuiButton
              fill
              isLoading={props.isLoading}
              isDisabled={props.isDisabled}
              onClick={onSaveClick}
            >
              Save
            </EuiButton>
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFormRow>
    </EuiPanel>
  );
};
